import axiosInstance from "@/services/axiosInterceptor";

export async function getGuideTasks(studentId) {
  try {
    const response = await axiosInstance.get(
      `${!studentId ? "guides/tasks" : `guides/tasks?studentId=${studentId}`}`
    );
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}

export async function markTaskAsComplete(taskId) {
  try {
    const response = await axiosInstance.post(`guides/task/${taskId}/complete`);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}
export async function createStudentTask(body) {
  try {
    const response = await axiosInstance.post(`guides/tasks`, body);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}
